// Apparence personnalisable des évènements (tournois / championnats)

export const TITLE_FONTS = {
  sport: { label: "Sport (défaut)", css: "" },
  elegant: { label: "Élégant (serif)", css: "'Playfair Display', serif" },
  modern: { label: "Moderne", css: "'Montserrat', sans-serif" },
  script: { label: "Manuscrit", css: "'Dancing Script', cursive" },
  retro: { label: "Rétro", css: "'Alfa Slab One', serif" },
};

export const TITLE_SIZES = {
  s: { label: "S", cls: "text-3xl sm:text-4xl md:text-5xl" },
  m: { label: "M", cls: "text-4xl sm:text-5xl md:text-6xl" },
  l: { label: "L (défaut)", cls: "text-4xl sm:text-6xl md:text-8xl" },
  xl: { label: "XL", cls: "text-5xl sm:text-7xl md:text-9xl" },
};

export const titleStyles = (ap = {}, def = "l") => ({
  sizeClass: (TITLE_SIZES[ap.title_size] || TITLE_SIZES[def] || TITLE_SIZES.l).cls,
  style: {
    ...(ap.title_color ? { color: ap.title_color, backgroundImage: "none", WebkitTextFillColor: ap.title_color } : {}),
    ...(TITLE_FONTS[ap.title_font]?.css ? { fontFamily: TITLE_FONTS[ap.title_font].css } : {}),
  },
});

export const themeVars = (ap = {}) => {
  const vars = {};
  if (ap.heading_color) vars["--ev-heading"] = ap.heading_color;
  if (ap.card_color) vars["--ev-card"] = ap.card_color;
  if (ap.text_color) vars["--ev-text"] = ap.text_color;
  return vars;
};

// Extraction des couleurs dominantes d'un logo/image (côté client)
export async function extractPalette(url, count = 5) {
  const img = await new Promise((resolve, reject) => {
    const i = new Image();
    i.crossOrigin = "anonymous";
    i.onload = () => resolve(i);
    i.onerror = reject;
    i.src = url;
  });
  const size = 64;
  const canvas = document.createElement("canvas");
  canvas.width = size;
  canvas.height = size;
  const ctx = canvas.getContext("2d");
  ctx.drawImage(img, 0, 0, size, size);
  const { data } = ctx.getImageData(0, 0, size, size);
  const buckets = {};
  for (let i = 0; i < data.length; i += 4) {
    const [r, g, b, a] = [data[i], data[i + 1], data[i + 2], data[i + 3]];
    if (a < 128) continue;
    const max = Math.max(r, g, b);
    const min = Math.min(r, g, b);
    if (max < 35 || min > 225 || max - min < 18) continue; // trop sombre/clair/gris
    const key = `${r >> 4},${g >> 4},${b >> 4}`;
    if (!buckets[key]) buckets[key] = { n: 0, r: 0, g: 0, b: 0 };
    const bk = buckets[key];
    bk.n++;
    bk.r += r;
    bk.g += g;
    bk.b += b;
  }
  const hex = (v) => Math.round(v).toString(16).padStart(2, "0");
  return Object.values(buckets)
    .sort((a, b) => b.n - a.n)
    .slice(0, count)
    .map((bk) => `#${hex(bk.r / bk.n)}${hex(bk.g / bk.n)}${hex(bk.b / bk.n)}`);
}
